import React, { useEffect, useState } from "react";

import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";

import FeatherIcon from "feather-icons-react";

import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../shared/actions/Authentication.actions";
import { Permissions } from "../../shared/models/Types";
import CustomerMaintanenceSmsModal from "./CustomerMaintanenceSmsModal";
import { useSmsMutation } from "./Company.actions";
import CustomerPaymentSmsModal from "./CustomerPaymentSmsModal";

const SmsTab = () => {
  const permissionList = useRecoilValue(permissionsSelector);

  const { data, mutate, isLoading } = useSmsMutation();

  const [isMaintanenceSmsModalOpen, setIsMaintanenceSmsModalOpen] =
    useState<boolean>(false);
  const [isPaymentUpdateModalOpen, setPaymentSmsIsModalOpen] =
    useState<boolean>(false);

  const toggleMaintanenceUpdate = () => {
    setIsMaintanenceSmsModalOpen(!isMaintanenceSmsModalOpen);
  };

  const togglePaymentUpdate = () => {
    setPaymentSmsIsModalOpen(!isPaymentUpdateModalOpen);
  };

  useEffect(() => {
    mutate({});
  }, []);

  const maintenanceSms = data?.find(
    (item) => item.content_type === "maintenance"
  );

  const paymentSms = data?.find((item) => item.content_type === "payment");

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="card-title mb-0">Bakım Sms</h5>
            </div>
            <div
              onClick={toggleMaintanenceUpdate}
              className="flex-shrink-0 pointer"
            >
              {<FeatherIcon icon="edit" />}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="pb-3">
            <Row>
              <Col>
                {!isLoading ? (
                  <div>
                    <h5 className="font-size-15">Sms Bilgisi:</h5>
                    {maintenanceSms?.content.length ? (
                      <p>{maintenanceSms.content}</p>
                    ) : (
                      <p>
                        Değerli Müşterimiz, Su Arıtma Cihazınızın bakım zamanı
                        gelmiştir. En yakın zamanda bizimle iletişime geçmenizi
                        önemle rica ediyoruz.
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    <p>
                      <span className="placeholder col-3"></span>
                    </p>
                    <p>
                      <span className="placeholder col-7"></span>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <div className="d-flex">
            <div className="flex-grow-1">
              <h5 className="card-title mb-0">Ödeme Sms</h5>
            </div>
            <div
              onClick={togglePaymentUpdate}
              className="flex-shrink-0 pointer"
            >
              {<FeatherIcon icon="edit" />}
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <div className="pb-3">
            <Row>
              <Col>
                {!isLoading ? (
                  <div>
                    <h5 className="font-size-15">Sms Bilgisi:</h5>
                    {paymentSms?.content.length ? (
                      <p>{paymentSms.content}</p>
                    ) : (
                      <p>
                        Değerli Müşterimiz, Toplam tutar $borc ₺ borcunuz
                        bulunmaktadır. Borcunuzu ödemenizi önemle rica ederiz.
                      </p>
                    )}
                  </div>
                ) : (
                  <>
                    <p>
                      <span className="placeholder col-3"></span>
                    </p>
                    <p>
                      <span className="placeholder col-7"></span>
                    </p>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>

      {isMaintanenceSmsModalOpen && (
        <CustomerMaintanenceSmsModal
          isModalOpen={isMaintanenceSmsModalOpen}
          toggle={toggleMaintanenceUpdate}
          smsData={data}
          mutate={mutate}
        />
      )}

      {isPaymentUpdateModalOpen && (
        <CustomerPaymentSmsModal
          isModalOpen={isPaymentUpdateModalOpen}
          toggle={togglePaymentUpdate}
          smsData={data}
          mutate={mutate}
        />
      )}
    </React.Fragment>
  );
};

export default SmsTab;
